import React from 'react';

export default function PlaceholderBook() {
    return (
        <div className='book-child-div'>
            <span role='img' aria-label='emoji finger pointing up'>
                ☝️
            </span>
            <h3>Humm... no books?</h3>
            <h3>Click "Add A Book" to start your library!</h3>
        </div>
    )
}